module.exports = __webpack_public_path__ + "static/media/ico_rule_o.817f4356.svg";